export const LOAD_ORGSTRUCTURES_SUCCESS = "LOAD_ORGSTRUCTURES_SUCCESS";

export const CREATE_ORGSTRUCTURE_SUCCESS = "CREATE_ORGSTRUCTURE_SUCCESS";

export const SAVE_ORGSTRUCTURE_SUCCESS = "SAVE_ORGSTRUCTURE_SUCCESS";

export const DELETE_ORGSTRUCTURE_SUCCESS = "DELETE_ORGSTRUCTURE_SUCCESS";

export const LOAD_ORGSTRUCTURE_DETAIL_SUCCESS = "LOAD_ORGSTRUCTURE_DETAIL_SUCCESS";

export const SET_CURRENT_ORGSTRUCTURE = "SET_CURRENT_ORGSTRUCTURE";

export const CREATE_ORGSTRUCTURE = "CREATE_ORGSTRUCTURE";
export const SAVE_ORGSTRUCTURE = "SAVE_ORGSTRUCTURE";

export const CLEAR_ORGSTRUCTURES = "CLEAR_ORGSTRUCTURES";
